import { Colors } from '../../../../public/GlobalTokens';

interface BackfillStatusConfig {
  color: string;
  icon: string;
  title: string;
  statusText: string;
  statusColor: string;
}

const BACKFILL_STATUS_MAP: Record<string, BackfillStatusConfig> = {
  ERROR: {
    color: 'destructive',
    icon: 'ClearCircle',
    title: 'View Error Details',
    statusText: 'Failed',
    statusColor: Colors.colorType.destructive.dark,
  },
  RUNNING: {
    color: 'brand',
    icon: 'Info',
    title: 'Backfill is running',
    statusText: 'Running',
    statusColor: Colors.colorType.brand.dark,
  },
  SUBMITTED: {
    color: 'warning',
    icon: 'Clock',
    title: 'Backfill submitted',
    statusText: 'Submitted',
    statusColor: Colors.colorType.warning.dark,
  },
  COMPLETED: {
    color: 'success',
    icon: 'CheckCircle',
    title: 'Backfill completed',
    statusText: 'Completed',
    statusColor: Colors.colorType.success.dark,
  },
};

const DEFAULT_STATUS: BackfillStatusConfig = {
  color: 'neutral',
  icon: 'NotAvailable',
  title: 'Unknown status',
  statusText: 'Unknown',
  statusColor: Colors.colorType.warning.dark,
};

export const getBackfillStatusIcon = (status: string) => {
  const { color, icon, title } = BACKFILL_STATUS_MAP[status] || DEFAULT_STATUS;
  return { colorConcept: color, icon, title };
};

export const getBackfillStatusText = (status: string) => {
  const config = BACKFILL_STATUS_MAP[status] || DEFAULT_STATUS;
  return {
    statusText: config.statusText,
    statusColor: config.statusColor,
  };
};
